<template>
  <div>
    <TopHeader class="bg-color-wrap" />
    <MainNavbar />
    <PageBanner pageTitle="Testimonials" />
    <PartnerLogo class="pt-100" />
    <OurClients />
    <OverView class="pt-100" />
    <MainFooter />
  </div>
</template>

<script>
import TopHeader from "../Layout/TopHeader";
import MainNavbar from "../Layout/MainNavbar";
import PageBanner from "../Common/PageBanner";
import PartnerLogo from "../Common/PartnerLogo";
import OurClients from "../Common/OurClients";
import OverView from "../Common/OverView";
import MainFooter from "../Layout/MainFooter";

export default {
  name: "TestimonialsPage",
  components: {
    TopHeader,
    MainNavbar,
    PageBanner,
    PartnerLogo,
    OurClients,
    OverView,
    MainFooter,
  },
};
</script>